import { cn } from "@/lib/utils";

export default function StepIndicator({ step, total }) {
  return (
    <div
      data-testid="onboarding-step-indicator"
      className="mb-8 flex items-center justify-center gap-2"
    >
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          data-testid={`step-dot-${i}`}
          data-active={i === step ? "true" : "false"}
          data-complete={i < step ? "true" : "false"}
          className={cn(
            "h-1.5 rounded-full transition-all duration-500",
            i === step
              ? "w-10 bg-white"
              : i < step
                ? "w-2 bg-white/70"
                : "w-2 bg-white/20",
          )}
        />
      ))}
    </div>
  );
}
